module.exports = __webpack_public_path__ + "static/media/iternal-new.fb40c647.svg";